// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"IframeEmbeddedCanvas_wrapper__ETE2C"};